import type {TreeItem} from '@pb/kit-component-tree-v2';

export const iterateLcdTreeCount = (
    tree: TreeItem,
    acc: string[],
    selected: {region: string, subscription: string}[],
    region: string,
) => {
    if (tree.children) {
        tree.children.forEach(child => {
            iterateLcdTreeCount(child, acc, selected, region);
        });
    } else {
        const existed = selected.find(e => (
            e.region === region && e.subscription === tree.id
        ));

        if (existed && !acc.includes(`${region}.${tree.id}`)) {
            acc.push(`${region}.${tree.id}`);
        }
    }
};
